import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';

export const WhatIsPersonaModal = ({
  hide,
  isShow,
}: {
  isShow: boolean;
  hide: () => void;
}) => {
  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-col">
            <div className="flex flex-row">
              <div className="text-lg font-bold">グループとは？</div>
              <div
                className="icon-close ml-auto text-gray-500 cursor-pointer"
                onClick={hide}
              />
            </div>
            <div className="mt-2 text-sm">
              アセプラユーザーの中から年齢、性別、資産、投資歴などの属性情報を組み合わせて統計したグループのことです。
            </div>
            <div className="mt-4 text-sm font-bold">
              このように使ってみましょう
            </div>
            <div className="mt-1 text-sm">
              自分と似たグループとの比較をすることで、ご自身の現状把握や資産傾向に気づく手助けとなります。
              <br />
              また、グループの特徴を変えて比較することで、自分より資産を増やしている人が何に投資をしているか発見できるかもしれません。
            </div>
            <button className="mt-4 p-2 text-center text-sm" onClick={hide}>
              閉じる
            </button>
          </div>
        </div>
      </Modal2>
    </>
  );
};
